import moment from 'moment';

export const PolicyholderValidation = () => {
  const validAge = (value) => {
    if (!value) return true;

    const age = moment().diff(moment(value, ['DD.MM.YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD']), 'years');

    return age >= 18 && age <= 100;
  };

  const validUkrainianPhoneNumber = (value) => {
    if (!value) return true;

    const cleanedPhone = value.replace(/\D/g, '');

    // Ukrainian phone number formats:
    // +380 XX XXX XX XX (12 digits with country code)
    // 380 XX XXX XX XX (11 digits without +)
    // 0XX XXX XX XX (10 digits local format)

    const isWithCountryCode = cleanedPhone.length === 12 && cleanedPhone.startsWith('380');
    const isWithoutPlus = cleanedPhone.length === 11 && cleanedPhone.startsWith('380');
    const isLocalFormat = cleanedPhone.length === 10 && cleanedPhone.startsWith('0');

    return isWithCountryCode || isWithoutPlus || isLocalFormat;
  };

  const validEmail = (value) => {
    if (!value) return true;

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(value);
  };

  const validEdrpou = (value) => {
    if (!value) return true;

    const cleaned = value.replace(/\s/g, '').trim();

    if (!/^\d{8}$/.test(cleaned)) {
      return false;
    }

    const digits = cleaned.split('').map(Number);

    const calcCheckDigit = (number) => {
      let weights = [1, 2, 3, 4, 5, 6, 7];

      if (['3', '4', '5'].includes(number[0])) {
        weights = [7, 1, 2, 3, 4, 5, 6];
      }

      const total = weights.reduce((sum, w, i) => sum + w * number[i], 0);
      const remainder = total % 11;

      if (remainder < 10) {
        return remainder;
      }

      const newWeights = weights.map(w => w + 2);
      const newTotal = newWeights.reduce((sum, w, i) => sum + w * number[i], 0);
      return newTotal % 11 % 10;
    };

    const checkDigit = calcCheckDigit(digits);
    return digits[7] === checkDigit;
  };

  return {
    validAge,
    validUkrainianPhoneNumber,
    validEmail,
    validEdrpou,
  };
};
